// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overflow-y: scroll;
}
.bdg {
  margin: 1px;
  display: inline-block;
  /* // color: #212529; */
  text-align: center;
  /* // vertical-align: middle; */
  /* // background-color: transparent; */
  border: 1px solid #17a2b8;
  /* // padding: .375rem .75rem; */
  /* // font-size: 1rem; */

  /* // border-radius: .25rem; */
  padding: 0.25rem 0.5rem;
  /* // font-size: .875rem; */
  line-height: 1.5;
  border-radius: 0.2rem;
}

div[attribute*="draggable"] {
  -webkit-user-select: unset !important;
          user-select: unset !important;
  background-color: red !important;
}

/*div[class\$="-container"] {
  background: #ffff00 !important;
  margin-bottom:'50px' !important;
}*/

.fixed-bottom {
  z-index: unset !important;
}

.navbar-brand {
  margin: auto !important;
}

@media only screen and (min-width: 769px) {
  .navbar-brand {
    display: none !important;
  }

  .navbar-brand.brand-middle {
    display: block !important;
  }
}

/* Timeline */
ul.timeline {
  list-style-type: none;
  position: relative;
}
ul.timeline:before {
  content: " ";
  background: #d4d9df;
  display: inline-block;
  position: absolute;
  left: 36px;
  width: 2px;
  height: 100%;
  z-index: 400;
}

ul.timeline > li {
  box-sizing: border-box;
  border: 1px solid transparent;
  /*// margin: 30px 0;
  // margin-top:20px;*/
  padding-bottom: 20px;
  padding-left: 20px;
}
ul.timeline > li:before {
  content: " ";
  text-align: center;
  line-height: 28px;
  background: white;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #17a2b8;
  left: 20px;
  width: 34px;
  height: 34px;
  z-index: 400;
}

ul.timeline > li.created:before {
  content: "✚";
  border: 3px solid #28a745;
}
ul.timeline > li.updated:before {
  content: "📝";
  border: 3px solid #17a2b8;
}
ul.timeline > li.removed:before {
  content: "🗑";
  border: 3px solid #dc3545;
}

ul.timeline > li > button {
  text-align: left;
}

ul.timeline a i {
  border-bottom: 1px dashed blue;
}

header nav.bg-info a.nav-link {
  color: white !important;
}

.container-fluid.p-3 {
  padding-top: 80px !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,sCAAsC;EACtC,yBAAyB;EACzB,gCAAgC;EAChC,wBAAwB;;EAExB,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qCAA6B;UAA7B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;;;EAGE;;AAEF;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B;sBACoB;EACpB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":["body {\n  overflow-y: scroll;\n}\n.bdg {\n  margin: 1px;\n  display: inline-block;\n  /* // color: #212529; */\n  text-align: center;\n  /* // vertical-align: middle; */\n  /* // background-color: transparent; */\n  border: 1px solid #17a2b8;\n  /* // padding: .375rem .75rem; */\n  /* // font-size: 1rem; */\n\n  /* // border-radius: .25rem; */\n  padding: 0.25rem 0.5rem;\n  /* // font-size: .875rem; */\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n\ndiv[attribute*=\"draggable\"] {\n  user-select: unset !important;\n  background-color: red !important;\n}\n\n/*div[class$=\"-container\"] {\n  background: #ffff00 !important;\n  margin-bottom:'50px' !important;\n}*/\n\n.fixed-bottom {\n  z-index: unset !important;\n}\n\n.navbar-brand {\n  margin: auto !important;\n}\n\n@media only screen and (min-width: 769px) {\n  .navbar-brand {\n    display: none !important;\n  }\n\n  .navbar-brand.brand-middle {\n    display: block !important;\n  }\n}\n\n/* Timeline */\nul.timeline {\n  list-style-type: none;\n  position: relative;\n}\nul.timeline:before {\n  content: \" \";\n  background: #d4d9df;\n  display: inline-block;\n  position: absolute;\n  left: 36px;\n  width: 2px;\n  height: 100%;\n  z-index: 400;\n}\n\nul.timeline > li {\n  box-sizing: border-box;\n  border: 1px solid transparent;\n  /*// margin: 30px 0;\n  // margin-top:20px;*/\n  padding-bottom: 20px;\n  padding-left: 20px;\n}\nul.timeline > li:before {\n  content: \" \";\n  text-align: center;\n  line-height: 28px;\n  background: white;\n  display: inline-block;\n  position: absolute;\n  border-radius: 50%;\n  border: 3px solid #17a2b8;\n  left: 20px;\n  width: 34px;\n  height: 34px;\n  z-index: 400;\n}\n\nul.timeline > li.created:before {\n  content: \"✚\";\n  border: 3px solid #28a745;\n}\nul.timeline > li.updated:before {\n  content: \"📝\";\n  border: 3px solid #17a2b8;\n}\nul.timeline > li.removed:before {\n  content: \"🗑\";\n  border: 3px solid #dc3545;\n}\n\nul.timeline > li > button {\n  text-align: left;\n}\n\nul.timeline a i {\n  border-bottom: 1px dashed blue;\n}\n\nheader nav.bg-info a.nav-link {\n  color: white !important;\n}\n\n.container-fluid.p-3 {\n  padding-top: 80px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
